import React from "react";

const socialLinks = [
    { href: "https://www.facebook.com/Minixithu", icon: "fab fa-facebook-f", label: "Facebook" },
    { href: "https://x.com/@MinixITHub", icon: "fab fa-twitter", label: "Twitter" },
    
    { href: "https://www.linkedin.com/company/minix-it-hub-pvt-ltd-", icon: "fab fa-linkedin-in", label: "LinkedIn" },
];

const usefulLinks = [
    { href: "/home", label: "Home" },
    { href: "/about", label: "About Us" },
    { href: "/services", label: "Services" },
    { href: "/portfolio", label: "Portfolio" },
    { href: "/contact", label: "Contact" },
    
];

export default function Footer() {
    return (
        <footer style={{ background: "#222", color: "#fff", padding: "40px 0 0 0" }}>
            <div className="col-md-12 row" style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                maxWidth: "1200px",
                margin: "0 auto",
                padding: "0 20px"
            }}>
                {/* Logo & Address */}
                <div  className="col-md-3 text-center mb-4"  >
                    <img
                        src="minix-logo.png"
                        alt="Minix IT Hub Logo"
                        style={{ width: 120, marginBottom: 16 }}
                    />
                    <div>
                        <strong>Minix IT Hub Pvt. Ltd.</strong>
                        <br />
                      B-6, 100, Vishveshvariya Nagar,<br />
                       Triveni , Jaipur (Rajasthan)<br />
                        INDIA
                       
                    </div>
                     <div className="col-md-12 text-center">
                        {socialLinks.map(link => (
                            <a
                            className="p-4"
                                key={link.href}
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={link.label}
                                style={{
                                    color: "#fff",
                                    fontSize: 32,
                                    textDecoration: "none",
                                    transition: "color 0.2s"
                                }}
                            >
                                <i className={link.icon}></i>
                            </a>
                        ))}
                    </div>
                </div>

                {/* Social Media */}
                <div  className="col-md-2 text-center mb-4" >
                    <h4 style={{ color: "#fff" }}>Our Services</h4>
                      <div className="col-md-12 text-center">  
                        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                            <li style={{ margin: "8px 0" }}>Web Development</li>
                            <li style={{ margin: "8px 0" }}>Mobile App Development</li>
                            <li style={{ margin: "8px 0" }}>Digital Marketing</li>
                            <li style={{ margin: "8px 0" }}>Cloud Solutions</li>
                            <li style={{ margin: "8px 0" }}>IT Consulting</li>
                        </ul>
                         </div>

                </div>
                <div  className="col-md-2 text-center mb-4" >  
                    <h4 style={{ color: "#fff" }}>Industries</h4>
                      <div className="col-md-12 text-center"> 
                        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                            <li style={{ margin: "8px 0" }}>Healthcare</li>     
                            </ul>
                            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                            <li style={{ margin: "8px 0" }}>Finance</li>                </ul>
                            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                            <li style={{ margin: "8px 0" }}>E-commerce</li>            </ul>            
                            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>           <li style={{ margin: "8px 0" }}>Education</li>               </ul>  
                            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>           <li style={{ margin: "8px 0" }}>Real Estate</li>             </ul>     
                            
                            </div>
                     </div>

                {/* Useful Links */}
                <div className="col-md-2 text-center mb-4" >
                    <h4 style={{ color: "#fff" }}>Useful Links</h4>
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                        {usefulLinks.map(link => (
                            <li key={link.href} style={{ margin: "8px 0" }}>
                                <a
                                    href={link.href}
                                    style={{ color: "#bbb", textDecoration: "none" }}
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Location */}
                <div className="col-md-3 text-center mb-4" >
                    <h4 style={{ color: "#fff" }}>Location</h4>
                    <iframe
                        title="Minix IT Hub Location"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.1345448402285!2d75.7835568!3d26.867466099999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db5177a826ee5%3A0x5aef4c866c010115!2sMiniX%20IT%20Hub%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1760345392162!5m2!1sen!2sin"
                        width="100%"
                        height="200"
                        style={{ border: 0, borderRadius: 8 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
            </div>
            <div style={{
                borderTop: "1px solid #333",
                marginTop: 30,
                padding: "16px 0",
                textAlign: "center",
                fontSize: 15,
                color: "#bbb"
            }}>
                &copy; 2013-2026 Minix IT Hub Pvt. Ltd. All rights reserved.
            </div>
            {/* FontAwesome CDN for icons */}
            <link
                rel="stylesheet"
                href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
            />
        </footer>
    );
}